import {Filter} from "@/dto/Pageable";

export class PayrollReportFilter implements Filter {

    employmentId: number | null = null;
    employeeId: number | null = null;
    employerId: number | null = null;
    startDate: Date | null = null;
    endDate: Date | null = null;
    category: string | null = null;
    page = 0;
    size = 10;

    constructor(init?: Partial<PayrollReportFilter>) {
        Object.assign(this, init);
    }
}